/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import InseeHistorique from './InseeHistorique';
import InseeTransfert from './InseeTransfert';
import PageInsee from './PageInsee';

/** Menu « Transmission INSEE > Transfert » : PACS en attente, comme la tuile du tableau de bord */
export const PageTransfertInsee = () => (
  <InseeTransfert actif pleinePage>
    {(vue) => <PageInsee vue={vue} data-testid="insee-transfert-page" />}
  </InseeTransfert>
);

/** Menu « Transmission INSEE > Historique » */
export const PageHistoriqueInsee = () => (
  <InseeHistorique actif pleinePage>
    {(vue) => <PageInsee vue={vue} data-testid="insee-historique-page" />}
  </InseeHistorique>
);
